import { Injectable, Injector } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GithubService } from "./github.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private clientId = environment.githubClientId; // ID client dell'app GitHub
  private clientSecret = environment.githubClientSecret; // Chiave segreta client dell'app GitHub
  private redirectUri = "https://www.insightest.app/apps/gitten/auth"; // L'URL di callback
  private scope = "repo"; // Permessi richiesti (repo per accesso completo ai repository)
  private authUrl = `https://github.com/login/oauth/authorize?client_id=${this.clientId}&scope=${this.scope}&redirect_uri=${this.redirectUri}`;
  private githubService: GithubService;

  constructor(private injector: Injector, private router: Router) {
    this.githubService = this.injector.get(GithubService);
  }

  login() {
    window.location.href = this.authUrl; // Reindirizza a GitHub per il login
  }

  getUser() {
    return this.githubService.getUser();
  }

  async handleAuthCallback() {
    const query =
      window.location.href.split("?")[1] ||
      sessionStorage.getItem("github_code");
    const params = new URLSearchParams(query);
    const code = params.get("code");
    if (code) {
      sessionStorage.removeItem("github_code");
      const res: any = await this.githubService.authenticate(code).toPromise();
      const accessToken = res.access_token;
      if (accessToken) {
        localStorage.setItem("github_token", accessToken);
        this.githubService.setAccessToken(accessToken);
        await this.githubService.getUser();
        this.router.navigate(["/pages/"]);
      }
    }
  }

  getToken() {
    return localStorage.getItem("github_token");
  }

  logout() {
    localStorage.removeItem("github_token");
    localStorage.removeItem("github_user");
    localStorage.removeItem("github_repo");
    localStorage.removeItem("access_token");
    localStorage.removeItem("github_repo_name");
    localStorage.removeItem("github_repo_owner");
    localStorage.removeItem("github_repo_branch");
    localStorage.removeItem("selectedRepo");
    localStorage.removeItem("selectedBranch");
  }
}
